import workflowState from "@/store/modules/workflow/workflowState.js";
import workflowAction from "@/store/modules/workflow/workflowAction.js";
import workflowMutation from "@/store/modules/workflow/workflowMutation.js";

const workflowStore = {
  state: workflowState,
  getters : {
    getAuthModal(){
      return workflowState.authModal;
    },
    getGroupCode(){
      return workflowState.groupCode;
    },
    getGroups(){
      return workflowState.groups;
    },
    getWorkflowActions(){
      return workflowState.workflowsS;
    }
  },
  mutations: workflowMutation,
  actions: workflowAction,
};

export default workflowStore;
